import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";

import { userLogout } from "../../../store/auth/auth.slice.js";
import {
  getUserFullName,
  getUserInitials,
  getAccountType,
  getUserLoginId,
} from "../../../store/auth/selectors.js";
import genius_logo from "../../../assets/images/genius_logo.svg";
import dropdown_icon from "../../../assets/images/dropdown_icon.svg";
import hamburger_icon from "../../../assets/images/hamburger_icon.svg";
import "./NavBar.css";

function NavBar({ onToggleSidebar, isSidebarOpen }) {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const popupRef = useRef(null);
  const iconRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userFullName = useSelector(getUserFullName);
  const userInitials = useSelector(getUserInitials);
  const userAccountType = useSelector(getAccountType);
  const userLoginId = useSelector(getUserLoginId);

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const handleClickOutside = (event) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      iconRef.current &&
      !iconRef.current.contains(event.target)
    ) {
      setIsPopupVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    dispatch(userLogout());
    navigate("/login", { state: { fromLogout: true } });
  };

  const dropdownVariants = {
    hidden: { opacity: 0, y: -20, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { type: "spring", stiffness: 300, damping: 25 },
    },
    exit: {
      opacity: 0,
      y: -20,
      scale: 0.95,
      transition: { duration: 0.2 },
    },
  };

  return (
    <div className="navBar">
      <button
        aria-label="Open menu"
        aria-expanded={!!isSidebarOpen}
        className="hamburger"
        onClick={onToggleSidebar}
      >
        <img src={hamburger_icon} alt="hamburger" />
      </button>
      <img src={genius_logo} alt="logo" className="navBar-logo" />
      <div className="user-info-container">
        <span className="user-full-name">{userFullName}</span>
        <span className="user-account-type">{userAccountType}</span>
      </div>
      <div className="navBar-profile">
        <div className="user-initials-circle">{userInitials}</div>
        <motion.div
          ref={iconRef}
          onClick={togglePopup}
          className="dropdown-icon"
          animate={{ rotate: isPopupVisible ? 180 : 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
        >
          <img src={dropdown_icon} alt="dropdown" />
        </motion.div>
        <AnimatePresence>
          {isPopupVisible && (
            <motion.div
              className="popup-logout"
              ref={popupRef}
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={dropdownVariants}
            >
              <div className="popup-user-info">
                <div className="popup-user-name">{userFullName}</div>
                <div className="popup-user-account-type">{userAccountType}</div>
              </div>
              <div className="popup-login-id">Login Id: {userLoginId}</div>
              <div className="popup-logout-button" onClick={handleLogout}>
                Logout
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default NavBar;
